export default __webpack_public_path__ + "static/media/big-shoe.7c7bcfcb.svg";